<template>
  <div class="cclink">

    <div v-if="inprogress">
        <span class="display-1">Working on it...
          <br /><v-progress-circular indeterminate></v-progress-circular>
        </span>
    </div>

    <div v-if="success">
        <span class="display-1 success--text">Stripe Card Processing Account Linked</span>
        <br />Complete! Your buyers can now use credit cards to pay.<br />
    </div>

    <div v-if="error">
      <h1 class="center">Error</h1>
      There was an error creating your account. <br />
      <b>{{ errorDescription }}</b>

      <br /><br />
      Go to <router-link to="sitesettings">Site Settings</router-link> and try again or
            <a href="mailto:help@smartkidsmarket.com?subject=Help Request">Contact Us</a> if the problem persists.
    </div>
    <div v-if="err">

      <span class="display-1 error--text">Error</span>
      <br />

      There was an error linking your account. <br />
      <b>{{ err }}</b>
      <br /><br />
      Go to <router-link to="sitesettings">Site Settings</router-link> and try again or
            <a href="mailto:help@smartkidsmarket.com?subject=Help Request">Contact Us</a>   if the problem persists.
    </div>

      <hr />
      <ReturnToDashboard></ReturnToDashboard>

</div>

</template>

<script>
// This page is the redirect from Stripe once a user's credit card is linked
// to our account.
// https://smartkidsmarket.com/artists/creditcardlinked?state=roZcBHBsZ6as2O6DEQWw&scope=read_write&code=ac_Dy41r7wn06x7cvXBg9Meu1eqwGBWG9XW

import {mapState} from 'vuex'
import config from '../../config.js'
import ReturnToDashboard from './ReturnToDashboard'


export default {
  name: 'CreditCardLinked',
  components: {
    ReturnToDashboard
  },
  data () {
    return {
      inprogress: false,
      err: null,
      success: false
    }
  },
  computed: {
    ...mapState({
    }),
    csrfToken () {
      return this.$route.query.state
    }, // Stripe CSRF token to verify
    scope () { return this.$route.query.scope }, // read_write
    code () { return this.$route.query.code || null }, // Code to get and link Stripe data to us
    error () { return this.$route.query.error || null }, // Code to get and link Stripe data to us
    errorDescription () { return this.$route.query.errorDescription || null } // Code to get and link Stripe data to us
  },
  async mounted () {
    // Start validating everything...
    if (!this.error) {
      // Do the linkage
      this.inprogress = true
      this.success = false
      try {
        // Now link them and charge the account
        var creditcardlinked = config.getFunctions().httpsCallable('creditcardlinked')
        const rc = await creditcardlinked(
          {
            csrfToken: this.csrfToken,
            scope: this.scope,
            code: this.code
          }
        )

        console.log('RC from update:' + JSON.stringify(rc))

        this.inprogress = false
        this.success = true

        // If all went well, we're logged in as the kid, go to their account
        this.updateSuccess = true
      } catch (err) {
        // console.error('ERROR linking the account: ' + JSON.stringify(err.code))
        // console.error('ERROR linking the account: ' + JSON.stringify(err.message))
        // console.error('ERROR linking the account: ' + JSON.stringify(err.details))
        if (err.details && err.details.error) {
          this.err = err.details.error.error_description
        } else {
          this.err = err.message
        }
        this.inprogress = false
      }
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.cclink {
  text-align: center;
}

.center {
  text-align: center;
}

</style>
